export default "__VITE_ASSET__84df028b__"